<template>
  <v-img
    :src="imageURL"
    aspect-ratio="1" contain
  ></v-img>
</template>
<script>
export default {
  props: {
    systembolagetNr: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      imageURL: ''
    }
  },
  mounted () {
    // Items have already been loaded'
    if (this.imageURL) {
      return
    }

    // Lazily load input items
    fetch('https://api.3ol3.nu/api/beverages/beers/' + this.systembolagetNr)
      .then(res => res.json())
      .then(res => {
        let result = null

        if (res.status) {
          result = res[0]
        }
        const baseURL = 'https://product-cdn.systembolaget.se/productimages/'
        const artikel_id = result.artikel_id
        this.imageURL = baseURL + artikel_id + '/' + artikel_id + '_200.png'
      })
  }
}
</script>
